import React, { useState, useEffect } from 'react';
import DiscussionCard from './NewDiscussionCard';

const Main = ({currentUserId}) => {
  const [discussions, setDiscussions] = useState([])
  const [selected, setSelected] = useState([])
  const [limit, setLimit] = useState(4)

  useEffect(() => {
    fetchDiscussions()
  }, [])

  const fetchDiscussions = () => {
    $.ajax({
      type: 'GET',
      data: {limit: limit},
      url: "/comments/fetch_discussions",
      success: function(data) {
        setDiscussions(data.discussions)
        setSelected(data.selected)
        setLimit(data.limit)
      }
    });
  }
  
  return (
    <div className="join-the-discussions-container">
      {discussions.map(function(discussion, idx) {
        return <DiscussionCard 
          discussion={discussion}
          selected={selected}
          setSelected={setSelected}
          position={idx + 1}
          currentUserId={currentUserId}
        />
      })}
    </div>
  )

}

export default Main;